<template>
  <div>
    <div
      v-if="sizeLoaded && (!isCompanyUser || (isCompanyUser && isCompanyOwner))"
      class="alert alert-warning"
      role="alert"
    >
      <div class="d-flex justify-content-between">
        <div>
          هزینه استفاده از سرویس فضای ابری به صورت روزانه و بر اساس حجم فایل‌های
          شما محاسبه میگردد.
        </div>
        <div>
          <span class="badge badge-secondary">
            حجم:
            <span dir="ltr">
              {{ bytesToHuman(directorySize) }}
            </span>
          </span>
          <span class="badge badge-secondary ml-2">
            قیمت:
            <span>
              <span dir="ltr" class="pr-1">
                {{ amount }}
              </span>
              <span>ریال</span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="card card-custom gutter-b">
      <div class="card-body p-1">
        <FileManager></FileManager>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import FileManager from "@/view/content/fileManager/FileManager";
import { mapGetters } from "vuex";
import { GET_DIRECTORY_SIZE } from "@/core/services/store/files.module";

export default {
  name: "files",
  components: { FileManager },
  data() {
    return {
      sizeLoaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "فایل‌ها" }]);
    this.$store.dispatch(SET_ACTIONS, {});
    this.getFilesSize();
  },
  computed: {
    ...mapGetters(["directorySize", "prices"]),
    amount() {
      if (this.directorySize && this.prices["storage"]) {
        return Math.round(
          this.bytesToGig(this.directorySize) * this.prices["storage"]
        );
      }
      return 0;
    }
  },
  methods: {
    getFilesSize() {
      this.sizeLoaded = false;

      this.$store
        .dispatch(GET_DIRECTORY_SIZE)
        .then(() => {
          this.sizeLoaded = true;
        })
        .catch(() => {
          this.sizeLoaded = true;
        });
    }
  }
};
</script>
